import { useState } from "react";
import { Icon } from "@iconify/react";
import { useAuth } from "../../contexts/AuthContext"; // 👈 IMPORT AuthContext
import ProfileIcon from "../ProfileIcon/ProfileIcon";
import "./Navbar.scss";
import DefaultLogo from "../../Images/Hrlabs_Logo.jpeg";
import DefaultProfileIcon from "../../Images/user-1.jpg";

const Navbar = ({ isSidebarOpen, onToggleSidebar }) => {
  // --- STATE MANAGEMENT ---
  const { user, logout } = useAuth(); // 👈 USE AuthContext

  const [menuState, setMenuState] = useState({
    isSearchExpanded: false,
    isPunchIn: false,
    openDropdown: null,
    quickAccessOpen: false,
  });

  // --- DERIVED DATA from AuthContext ---
  // All user data now comes directly from the 'user' object from the context.
  const logoImageSrc =
    user?.logo && user?.logoType
      ? `data:${user.logoType};base64,${user.logo}`
      : DefaultLogo;
  const profileImageSrc =
    user?.profileImage && user?.profileImageType
      ? `data:${user.profileImageType};base64,${user.profileImage}`
      : DefaultProfileIcon;
  const companyName = user?.companyName || "HRLabs";
  const employeeName = user?.employeeName || "Employee";
  const role = user?.role || "No Role Assigned";

  const handleLogout = () => {
    logout(); // 👈 Use the logout function from AuthContext
  };

  const handleLogoError = (e) => {
    console.warn("Logo failed to load, falling back to default logo");
    e.currentTarget.src = DefaultLogo;
  };

  // If the user is not logged in, don't render the navbar.
  if (!user) {
    return null;
  }

  // --- RENDER ---
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button
          type="button"
          className="mobile-menu-toggle"
          onClick={onToggleSidebar}
          aria-label={isSidebarOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isSidebarOpen}
          aria-controls="admin-navigation"
        >
          <Icon icon={isSidebarOpen ? "mdi:close" : "mdi:menu"} />
        </button>
        <img
          src={logoImageSrc}
          alt="Company Logo"
          className="company-logo"
          onError={handleLogoError}
        />
        <span className="company-name">{companyName}</span>
      </div>
      <div className="navbar-right">
        {/* Profile Dropdown Menu */}
        <div
          className="profile-menu-container"
          onMouseEnter={() =>
            setMenuState((prev) => ({ ...prev, openDropdown: "profile" }))
          }
          onMouseLeave={() =>
            setMenuState((prev) => ({ ...prev, openDropdown: null }))
          }
        >
          <button className="profile-button" aria-label="Profile Menu">
            <ProfileIcon
              size="small"
              src={profileImageSrc}
              alt="Profile"
              className="profile-avatar"
            />
            <Icon icon="mdi:chevron-down" />
          </button>
          {menuState.openDropdown === "profile" && (
            <div className="profile-menu">
              <div className="profile-info">
                <ProfileIcon
                  size="medium"
                  src={profileImageSrc}
                  alt="Profile"
                />
                <div className="profile-details">
                  <div className="profile-name">{employeeName}</div>
                  <div className="profile-role">
                    <span className="role">
                      {role
                        .replace("ROLE_", "")
                        .toLowerCase()
                        .split("_")
                        .map(
                          (word) => word.charAt(0).toUpperCase() + word.slice(1)
                        )
                        .join(" ")}
                    </span>
                  </div>
                </div>
              </div>
              <div className="profile-options">
                <button className="logout-a" onClick={handleLogout}>
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
